export default function IconCloudUpload({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <path
        d="M12.7662 11.7962H13.8156C13.8156 11.7962 16.9062 11.393 16.9062 8.35842C16.9066 7.8967 16.8137 7.43967 16.6332 7.01468C16.4526 6.5897 16.1882 6.20554 15.8557 5.88521C15.5231 5.56487 15.1293 5.31497 14.6979 5.15047C14.2664 4.98596 13.8062 4.91025 13.3448 4.92785C12.8897 3.96177 12.1256 3.17485 11.1734 2.6914C10.2211 2.20796 9.13491 2.05555 8.0864 2.25823C7.03783 2.46091 6.0867 3.00715 5.38321 3.81065C4.67972 4.61416 4.26397 5.62914 4.20163 6.69526C3.82654 6.61638 3.43858 6.62215 3.06601 6.71214C2.69343 6.80214 2.34562 6.9741 2.0479 7.2155C1.75018 7.4569 1.51004 7.76165 1.34498 8.10758C1.17992 8.45351 1.0941 8.83194 1.09375 9.21517C1.09375 11.835 3.84369 11.794 3.84369 11.794H12.7662V11.7962Z"
        fill="none"
      />
      <path
        d="M13.8156 9.99953H3.84369C3.84369 9.99953 1.80316 10.0297 1.2375 8.36365C1.1422 8.6375 1.09361 8.92536 1.09375 9.21537C1.09375 11.8352 3.84369 11.7942 3.84369 11.7942H13.8156C13.8156 11.7942 16.9062 11.3932 16.9062 8.35862C16.9062 8.0676 16.8692 7.7778 16.7963 7.49609C16.2457 9.68184 13.8156 9.99953 13.8156 9.99953Z"
        fill="none"
      />
      <path
        d="M12.0906 11.7962H13.8156C13.8156 11.7962 16.9062 11.393 16.9062 8.35842C16.9066 7.8967 16.8137 7.43967 16.6332 7.01468C16.4526 6.5897 16.1882 6.20554 15.8557 5.88521C15.5231 5.56487 15.1293 5.31497 14.6979 5.15047C14.2664 4.98596 13.8062 4.91025 13.3448 4.92785C12.8897 3.96177 12.1256 3.17485 11.1734 2.6914C10.2211 2.20796 9.13491 2.05555 8.0864 2.25823C7.03783 2.46091 6.0867 3.00715 5.38321 3.81065C4.67972 4.61416 4.26397 5.62914 4.20163 6.69526C3.82654 6.61638 3.43858 6.62215 3.06601 6.71214C2.69343 6.80214 2.34562 6.9741 2.0479 7.2155C1.75018 7.4569 1.51004 7.76165 1.34498 8.10758C1.17992 8.45351 1.0941 8.83194 1.09375 9.21517C1.09375 11.835 3.84369 11.794 3.84369 11.794H5.90147"
        stroke="currentColor"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 7.84375V15.75"
        stroke="currentColor"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1562 10L9 7.84375L6.84375 10"
        stroke="currentColor"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
